import { Stack } from '@asgard/ui-library';
import Page from 'components/layout/Page';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { createGlobalStyle } from 'styled-components';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { CompaniesPageProps } from './FreelanceTalentPage.types';
import { Hero } from './hero/Hero';

import dynamic from 'next/dynamic';

const Features = dynamic(() => import('./features/Features'), {
  ssr: false
});

export const FreelanceTalentPage: React.FC<CompaniesPageProps> = ({
  bannerText
}) => {
  const { t } = useI18n('freelance-talent');

  const PageGlobalStyles = createGlobalStyle`
      #freshworks-container iframe {
        bottom: 90px !important;
      }
    `;

  return (
    <>
      <PageGlobalStyles />
      <HeadMetadata
        title={t('freelance-talent.page_title')}
        desc={t('freelance-talent.page_description')}
        url={APP_URLS.freelanceTalent}
        imgUrl={`${getPublicPath('/images/cards/card_freelance_talent.png')}`}
        indexable={true}
      />
      <Page hasScrollTop pageVariant="midnight_light" bannerText={bannerText}>
        <Stack direction="column" gap="5xl">
          <Hero />
          <Features />
        </Stack>
      </Page>
    </>
  );
};
